import { UtcDate } from '@/helpers/date';

export const parseCompareDate = compare => {
  const date = new UtcDate(compare);

  // return parsed date if it's valid
  if (date.isValid()) return date;

  const today = new UtcDate();

  // return today as a fallback
  if (!compare || compare === 'today') return today.startOfDay();

  // parse logic for shifted values
  if (compare.indexOf(' ') > -1 && compare.split(' ').length === 2) {
    const [shift, unit] = compare.split(' ');
    const absShift = Math.abs(+shift);
    const isSubtract = shift.indexOf('-') > -1;
    switch (unit) {
      case 'years':
      case 'year':
        return (isSubtract ? today.subYears(absShift) : today.addYears(absShift)).startOfDay();
      case 'day':
      case 'days':
        return (isSubtract ? today.subDays(absShift) : today.addDays(absShift)).startOfDay();
      default:
        // todo - add support for weeks, months etc.
        console.log('Not supported compare value for `after` validation rule');
        return today;
    }
  }

  return today;
};
